import { debounce } from '../../module/timing.js';
import CSSRuleSet from '../style/ruleset.js';
export default class SurfaceObserver {
    static stylesheet = new CSSRuleSet(':root {}');
    static entries = {};
    update = debounce(this.refresh.bind(this), 300);
    observer = new ResizeObserver(this.update.bind(this));
    element;
    options;
    constructor(element, options) {
        this.element = element;
        this.options = SurfaceObserver.fillOptions(element, options);
        this.observe();
    }
    observe() {
        if (SurfaceObserver.entries[this.options.name]) {
            console.warn(`Cannot overwrite existing Observer with name "${this.options.name}". \n Please define a unique name.`);
            return;
        }
        SurfaceObserver.entries[this.options.name] = {};
        if (this.options.initial) {
            const height = this.element.offsetHeight;
            const width = this.element.offsetWidth;
            this.saveProperties(height, width, true);
        }
        if (this.options.initial !== 'only') {
            this.observer.observe(this.element, {
                box: 'border-box'
            });
        }
    }
    refresh(entries) {
        for (const entry of entries) {
            const height = entry.borderBoxSize[0].blockSize;
            const width = entry.borderBoxSize[0].inlineSize;
            this.saveProperties(height, width);
        }
    }
    saveProperties(height, width, initial = false) {
        const state = initial ? this.options.suffix.initial : this.options.suffix.current;
        const suffix = this.options.pixel ? 'px' : '';
        if (this.options.height) {
            SurfaceObserver.stylesheet.setProperty(':root', `--${this.options.name}-${this.options.suffix.height}-${state}`, height.toFixed() + suffix);
        }
        if (this.options.width) {
            SurfaceObserver.stylesheet.setProperty(':root', `--${this.options.name}-${this.options.suffix.width}-${state}`, width.toFixed() + suffix);
        }
        SurfaceObserver.entries[this.options.name][(initial ? 'initial' : 'current')] = {
            height,
            width
        };
    }
    static fillOptions(element, options) {
        return {
            name: options?.name ?? element.tagName.toLowerCase(),
            suffix: {
                height: options?.suffix?.height ?? 'y',
                width: options?.suffix?.width ?? 'x',
                initial: options?.suffix?.initial ?? 'init',
                current: options?.suffix?.current ?? 'cur'
            },
            height: options?.height ?? true,
            width: options?.width ?? false,
            initial: options?.initial ?? true,
            pixel: options?.pixel ?? true
        };
    }
    static __init() {
        document.adoptedStyleSheets.push(SurfaceObserver.stylesheet.getStylesheet());
    }
}
SurfaceObserver.__init();
